<template>
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 512 512"><path d="M0 0v512h512V0zm160.66 482H30V351.33h130.66zm0-160.67H30V190.66h130.66zm0-160.67H30V30h130.66zM321.33 482H190.66V351.33h130.67zm0-160.67H190.66V190.66h130.67zm0-160.67H190.66V30h130.67zM482 482H351.33V351.33H482zm0-160.67H351.33V190.66H482zm0-160.67H351.33V30H482z"/></svg>
</template>
